<template>
	<div class="FrontAdminHub fa-page">
		<common-body :aside="module.aside">
			<div slot="commonMain">
				<div v-if="!entered" class="fa-gate">
					<div class="fa-gate__inner">
						<h1 class="fa-gate__title">{{ module.title }}</h1>
						<p class="fa-gate__desc">{{ module.desc }}</p>
						<div class="fa-gate__entries">
							<button
								v-for="item in module.sections"
								:key="item.key"
								type="button"
								class="fa-gate__entry"
								@click="enter(item.key)">
								<span class="fa-gate__entry-title">{{ item.title }}</span>
								<span class="fa-gate__entry-desc">{{ item.desc }}</span>
							</button>
						</div>
					</div>
				</div>
				<template v-else>
					<div class="fa-section-bar">
						<button type="button" class="fa-back-btn" @click="back">
							<i class="el-icon-arrow-left"></i> 返回入口
						</button>
						<span class="fa-section-bar__label">{{ currentTitle }}</span>
					</div>
					<section v-if="currentResource === 'money'" class="fa-card fa-money">
						<p class="fa-hint" style="border: 0; padding: 0 0 16px;">{{ moneyNote || '向指定会员发起企业付款提现。' }}</p>
						<el-form label-width="88px">
							<el-form-item label="用户 ID">
								<el-input-number v-model="moneyForm.user_id" :min="1" style="width: 100%" />
							</el-form-item>
							<el-form-item label="金额">
								<el-input-number v-model="moneyForm.price" :min="1" :precision="2" style="width: 100%" />
							</el-form-item>
							<el-form-item>
								<el-button type="primary" :loading="moneySaving" @click="submitMoney">确认提现</el-button>
							</el-form-item>
						</el-form>
					</section>
					<section v-else class="fa-card">
						<front-crud
							:key="currentResource"
							:resource="currentResource"
							:can-add="canAdd"
							:can-edit="canEdit"
							:can-del="canDel" />
					</section>
				</template>
			</div>
		</common-body>
	</div>
</template>

<script>
import FrontCrud from '@/components/FrontCrud/index.vue';
import { FRONT_ADMIN_MODULES, frontAdminCan } from '@/utils/front-admin-catalog';

export default {
	name: 'FrontAdminHub',
	components: { FrontCrud },
	props: {
		moduleKey: { type: String, required: true },
	},
	data() {
		return {
			entered: false,
			sectionKey: '',
			ruleList: JSON.parse(localStorage.getItem('ruleList') || '{}'),
			moneyForm: { user_id: undefined, price: 1 },
			moneySaving: false,
			moneyNote: '',
		};
	},
	computed: {
		module() {
			return FRONT_ADMIN_MODULES[this.moduleKey] || { title: '', desc: '', aside: '1', sections: [], rule: '' };
		},
		current() {
			return this.module.sections.find((s) => s.key === this.sectionKey) || this.module.sections[0] || {};
		},
		currentTitle() {
			return this.current.title || this.module.title;
		},
		currentResource() {
			return this.current.resource || '';
		},
		canAdd() {
			return frontAdminCan(this.ruleList, this.module.rule, 'add');
		},
		canEdit() {
			return frontAdminCan(this.ruleList, this.module.rule, 'edit');
		},
		canDel() {
			return frontAdminCan(this.ruleList, this.module.rule, 'del');
		},
	},
	beforeRouteLeave(to, from, next) {
		this.entered = false;
		this.sectionKey = '';
		next();
	},
	created() {
		const section = this.$route.query.section;
		if (section) this.enter(String(section), true);
		else if (this.module.sections.length === 1) this.enter(this.module.sections[0].key);
	},
	watch: {
		'$route.query.section'(val) {
			if (val) this.enter(String(val), true);
			else {
				this.entered = false;
				this.sectionKey = '';
			}
		},
	},
	methods: {
		enter(key, fromRoute) {
			const exists = this.module.sections.some((s) => s.key === key);
			this.sectionKey = exists ? key : (this.module.sections[0] && this.module.sections[0].key) || '';
			this.entered = true;
			if (this.sectionKey && this.$route.query.section !== this.sectionKey) {
				this.$router.replace({ path: this.$route.path, query: { section: this.sectionKey } });
			}
			if (this.currentResource === 'money') this.loadMoneyMeta();
		},
		back() {
			this.entered = false;
			this.sectionKey = '';
			if (this.$route.query.section) {
				this.$router.replace({ path: this.$route.path });
			}
		},
		loadMoneyMeta() {
			const that = this;
			that.$fetch('addons/hlm/api.FrontAdmin/manageMeta', { resource: 'money', action: 'meta' }).then(function(res) {
				if (res.code === 1) that.moneyNote = (res.data && res.data.note) || '';
			});
		},
		submitMoney() {
			const that = this;
			if (!that.moneyForm.user_id) {
				that.$message.warning('请输入用户 ID');
				return;
			}
			that.moneySaving = true;
			that.$post('addons/hlm/api.FrontAdmin/manageAction', {
				resource: 'money',
				action: 'transfer',
				user_id: that.moneyForm.user_id,
				price: that.moneyForm.price,
			}).then(function(res) {
				if (res.code === 1) {
					that.$message.success(res.msg || '提现成功');
					that.moneyForm.price = 1;
				}
			}).finally(function() {
				that.moneySaving = false;
			});
		},
	},
};
</script>

<style src="../../assets/css/front-admin.css"></style>
